export default {
  SKILL_TREE: 'skillTree',
  ISSUE_LIST_BREAK_POINT: 'issueListBreakPoint',
  COURSE_LEARNING_RECORD: 'courseLearningRecord',
  QUIZ_BREAKPOINT: 'quiz-breakpoint'
}
